import type { KennelDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/pet';
import {
    getCoverageTermValue,
    formatAmountToDK,
    formatAmountWithCurrency,
    isCoverageSelected
} from '../coverableDetailsInsuranceSumsConfig';
import { type TableInformation } from '../../../../config/flavourConfig';

const getKennelInsuranceSumsCoverableDetailsConfig = (
    kennelCoverable: KennelDTO
): TableInformation => {
    return {
        title: 'Forsikringssummer',
        rowsInformation: [
            {
                name: 'Ansvar ved skade på personer',
                fieldValue: formatAmountWithCurrency(
                    formatAmountToDK(
                        getCoverageTermValue(
                            kennelCoverable,
                            'PETLiabilityCov',
                            'PETLiabilityCovPersonSum'
                        )
                    )
                ),
                valueType: 'amount',
                hidden: !isCoverageSelected(kennelCoverable, 'PETLiabilityCov')
            },
            {
                name: 'Ansvar ved skade på dyr og ting',
                fieldValue: formatAmountWithCurrency(
                    formatAmountToDK(
                        getCoverageTermValue(
                            kennelCoverable,
                            'PETLiabilityCov',
                            'PETLiabilityCovAnimalSum'
                        )
                    )
                ),
                valueType: 'amount',
                hidden: !isCoverageSelected(kennelCoverable, 'PETLiabilityCov')
            }
        ]
    };
};

export { getKennelInsuranceSumsCoverableDetailsConfig };
